'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import { LangSwitch, useLang } from '@/lib/i18n';
import styles from '../styles/Home.module.css';

const PLATFORM_URL = 'https://app.umno.cloud';
const SITE_URL = 'https://umno.cloud';

export default function Page() {
  const router = useRouter();
  const { lang, setLang, t } = useLang();
  const [e2ee, setE2ee] = useState(false);
  const [passphrase, setPassphrase] = useState(randomString(64));
  const [code, setCode] = useState('');

  const go = (room: string) =>
    router.push(`/rooms/${room}${e2ee ? `#${encodePassphrase(passphrase)}` : ''}`);
  const join = (ev: React.FormEvent) => {
    ev.preventDefault();
    const m = code.trim().match(/rooms\/([^/?#\s]+)/);
    const room = (m ? m[1] : code.trim()).replace(/[^A-Za-z0-9_-]/g, '');
    if (room) go(room);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <LangSwitch lang={lang} setLang={setLang} />
        <div className="header">
          <a href={SITE_URL}>
            <img src="/images/umno-logo-dark.svg" alt="umno" width="300" height="94" />
          </a>
          <h2>{t('tagline')}</h2>
        </div>
        <div className={styles.tabContainer}>
          <div className={styles.tabContent}>
            <button className="lk-button umno-primary" onClick={() => go(generateRoomId())}>
              {t('start')}
            </button>
            <p className={styles.hint}>{t('share')}</p>
            <form onSubmit={join} style={{ display: 'flex', gap: '0.5rem' }}>
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder={t('code')}
                aria-label={t('code')}
                style={{ flex: 1, minWidth: 0 }}
              />
              <button className="lk-button" type="submit">
                {t('join')}
              </button>
            </form>
            <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
              <input type="checkbox" checked={e2ee} onChange={(ev) => setE2ee(ev.target.checked)} />
              {t('e2ee')}
            </label>
            {e2ee && (
              <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                {t('passphrase')}
                <input
                  type="password"
                  value={passphrase}
                  onChange={(ev) => setPassphrase(ev.target.value)}
                  style={{ flex: 1, minWidth: 0 }}
                />
              </label>
            )}
          </div>
        </div>
      </main>
      <footer data-lk-theme="default">
        <a href={SITE_URL}>umno.cloud</a> · <a href={PLATFORM_URL}>{t('platform')}</a> ·{' '}
        <a href="mailto:edu@umno.cloud">edu@umno.cloud</a>
      </footer>
    </>
  );
}
